export default __webpack_public_path__ + "static/media/0-Mars.52cb1bc3.svg";